import Label from "components/general/Label"
import { filterArray, findArray } from 'helpers/utils'
import { ResultRank } from "components/presentation/ResultRank"

export const APPARATUS = {
    "MEN": ['FX', 'PH', 'SR', 'VT', 'PB', 'HB'],
    "WOMEN": ['VT', 'UB', 'BB', 'FX']
};

export const PHASE = {
    "FINAL": "FNL-",
    "QUAL": "QUAL"
};

export const EVENT = {
    "TEAM": "TEAM--------------",
    "ALL_AROUND": "1AA---------------"
};




export function isQualification(phase) {
    return (phase.match("QUAL"));
}

export function isIndAllAround(rsc) {
    return (rsc.match("GAR.1AA-.+"));
}

export function isTeam(rsc) {
    return (rsc.match("GAR.TEAM-.+"));
}

export function isVaultEvent(event) {
    return (event.match("1APVT-.+"));
}

export function isTeamFinal(rsc) {
    return (rsc.match("GAR.TEAM--------------FNL-.+"));
}

export function isIndFinalApparatus(rsc) {
    return (rsc.match("GAR.1AP(FX|PH|SR|VT|PB|HB|UB|BB)-------------FNL-.+"));
}

export function getApparatusFromEvent(event) {
    return (event.substring(3, 5));
}
